import React from "react";
import styled from "styled-components";
import theme from "../../style/theme";

interface Props {
  progress: number;
}

const LinearProgressBar: React.FC<Props> = ({ progress }) => {
  return (
    <ProgressBarContainer>
      <ProgressBarInner style={{ width: `${progress}%` }} />
    </ProgressBarContainer>
  );
};

export default LinearProgressBar;

const ProgressBarContainer = styled.div`
  width: 340px;
  height: 8px;
  background-color: ${theme.palette.primitives.gray100};
  border-radius: 4px;
  overflow: hidden;
`;

const ProgressBarInner = styled.div`
  height: 100%;
  background-color: ${theme.palette.primitives.yellow400};
  transition: width 0.3s ease-in-out;
`;
